module.exports = __webpack_public_path__ + "static/media/Icon_ZoomOut.2fc78ca2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_ZoomOut.svg
// module id = 2324
// module chunks = 0